import { Controller, useFormContext } from "react-hook-form";
import { RadioGroup, RadioGroupProps } from "./radio-group";

export type ControlledRadioGroupProps<T extends string | number | boolean> =
  Omit<RadioGroupProps<T>, "onValueChange" | "errorMessage"> & {
    name: string;
  };

export function ControlledRadioGroup<T extends string | number | boolean>(
  props: ControlledRadioGroupProps<T>,
) {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={props.name}
      render={({ field, fieldState }) => {
        return (
          <RadioGroup
            {...field}
            {...fieldState}
            onValueChange={(value) => {
              field.onChange(value);
            }}
            {...props}
            errorMessage={fieldState?.error?.message}
            isInvalid={!!fieldState?.error?.message}
          />
        );
      }}
    />
  );
}
